import type { RoundKind } from './rounds';

/**
 * Broker: Deriv (Options API, packages/deriv).
 *
 * Each round clock runs on an asset set once per server process at startup (DERIV_RISE_FALL_SYMBOL,
 * DERIV_DIGITS_SYMBOL): by default both games run on the Volatility 100 (1s) Index — a synthetic
 * index that ticks every second, 24/7, with no market pauses.
 */
export const DEFAULT_ROUND_SYMBOLS: Readonly<Record<RoundKind, string>> = { RISE_FALL: '1HZ100V', EVEN_ODD: '1HZ100V' };

let rounds: Record<RoundKind, string> = { ...DEFAULT_ROUND_SYMBOLS };

export function configureRounds(symbols: Partial<Record<RoundKind, string>>): void {
  for (const [kind, symbol] of Object.entries(symbols) as [RoundKind, string | undefined][]) if (symbol) rounds[kind] = symbol;
}

/** The asset a round clock runs on. */
export function roundSymbolFor(kind: RoundKind): string {
  return rounds[kind];
}

/** Every clock's asset: { RISE_FALL, EVEN_ODD }. */
export function roundSymbolMap(): Readonly<Record<RoundKind, string>> {
  return rounds;
}

/** Assets the timed rounds run on (each once). */
export function roundSymbols(): readonly string[] {
  return [...new Set(Object.values(rounds))];
}

/** Clocks that run on this asset (none for a Traderoom-only asset). */
export function roundKindsOf(symbol: string): RoundKind[] {
  return (Object.keys(rounds) as RoundKind[]).filter((k) => rounds[k] === symbol);
}

/** Sobe e Desce's asset: the Rush and the defaults of screens that show one asset. */
export function primaryRoundSymbol(): string {
  return rounds.RISE_FALL;
}

/** Deriv symbol codes (active_symbols `underlying_symbol`): 1HZ100V, R_100, frxEURUSD, cryBTCUSD… */
export const DERIV_SYMBOL_RE = /^\w{2,30}$/;
